import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Login } from "./components/Login";
import { toAbsoluteUrl } from "../../helpers";
import { Registration } from "./components/Registration";
import { ForgotPassword } from "./components/ForgotPassword";
import { useEffect, useState } from "react";
import ChangePassword from "./components/ChangePassword";
import VerificationLink from "./components/VerificationLink";
import ResetPassword from "./components/ResetPassword";

import WorkshopLogin from "./components/AdminLogin";
import WorkshopAdminLogin from "./components/WorkshopAdminLogin";

const AuthLayout = () => {
  const fetchingTenant = window.location.hostname.split(".")[0];
  const [botId, setBotId] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 440);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 400);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 440);
      setIsSmallMobile(window.innerWidth <= 400);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const location = useLocation();
  const loginRelatedPaths = [
    "/auth/login",
    "/auth/registration",
    "/auth/forgot-password",
    "/auth/update-password",
    "/auth/reset-password",
    "/auth/email-sent",
  ];
  const isRouteLoginSelected = loginRelatedPaths.includes(location.pathname);
  const isAuthEmailSent = location.pathname === "/auth/email-sent";

  useEffect(() => {
    const fetchBotId = async () => {
      if (!fetchingTenant) return;

      try {
        // Remove "graphql" from the URL if it exists
        const apiUrl = process.env.REACT_APP_GRAPHQL_API_URL?.replace(
          /\/?graphql\/?$/,
          ""
        );

        const response = await fetch(
          `${apiUrl}/tenant/get-bots/${fetchingTenant}`
        );
        const data = await response.json();
        if (data && data.data[0].appIDString) {
          setBotId(data.data[0].appIDString); // Assuming the first bot is the one needed
        }
      } catch (error) {
        console.error("Error fetching bot ID:", error);
      }
    };

    fetchBotId();
  }, [fetchingTenant]);

  useEffect(() => {
    if (botId) {
      (function (d, m) {
        var botgoSettings = {
          appId: botId,
          "botgo-primary-color": "",
          "botgo-bot-bubble-color": "",
          "botgo-header-height": "60px",
          initiallyShow: false,
        };
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        var ts = Math.round(Date.now() / 1000);
        s.src = "https://botgo.io/chatbotPluginProd/embedd.js?t" + ts;
        var h = document.getElementsByTagName("head")[0];
        h.appendChild(s);
        (window as any).botgo = m;
        m._globals = botgoSettings;
      })(document, (window as any).botgo || {});
    }
  }, [botId]);

  return (
    <div
      className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
      style={{
        backgroundImage: isRouteLoginSelected
          ? `url(${toAbsoluteUrl("/media/illustrations/dozzy-1/14.png")})`
          : "",
      }}
    >
      {/* begin::Content */}
      <div
        className="d-flex flex-center flex-column flex-column-fluid mt-10 p-10 pb-lg-20"
        style={{
          background:
            !isRouteLoginSelected &&
            "linear-gradient(180deg, #E2784C, #99908C)",
        }}
      >
        {/* begin::Logo */}
        {/* begin::Logo */}
        {isRouteLoginSelected ? (
          <a href="#" className="mb-12 position-absolute top-0 start-0">
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/CircleOne.png")}
              className="h-40px h-sm-50px h-md-60px h-lg-70px"
            />
          </a>
        ) : (
          ""
        )}
        {/* end::Logo */}

        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div
          className={`bg-white rounded shadow-sm p-10 p-lg-15 mx-auto ${!isAuthEmailSent ? "w-lg-500px" : ""
            }`}
        >
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      {isRouteLoginSelected ? (
        <div
          className="d-flex flex-center flex-column-auto p-5"
          style={{ flexDirection: "column", gap: "20px" }}
        >
          <div className="d-flex align-items-center fw-bold fs-6">
            <a
              href="https://botgo.io/aboutus"
              className="text-muted text-hover-primary px-2"
            >
              About
            </a>
            <a
              href="https://botgo.io/#contact"
              className="text-muted text-hover-primary px-2"
            >
              Contact Us
            </a>
            <a
              href="https://botgo.io/privacy-policy"
              className="text-muted text-hover-primary px-2"
            >
              Privacy Policy
            </a>
          </div>
          <div>
            <h5
              className="footer-text"
              style={{
                fontSize: isSmallMobile ? "11.5px" : isMobile ? "12.5px" : "14px",
              }}
            >
              Powered by Botgo Technologies Pvt. Ltd © {new Date().getFullYear()}
            </h5>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* end::Footer */}
    </div>
  );
};

const AuthPage = () => {
  const location = useLocation();

  return (
    <Routes location={location}>
      <Route element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
        {/* <Route path="customer-login" element={<CustomerLogin fetchVehicles={''}/>} /> */}
        <Route path="admin-login" element={<WorkshopLogin />} />
        <Route path="workshop-admin-login" element={<WorkshopAdminLogin />} />

        {/* <Route path="customer-authenticate" element={<CustomerOTPPage />} /> */}
        <Route path="registration" element={<Registration />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="update-password" element={<ChangePassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="email-sent" element={<VerificationLink />} />

        {/* Only one index route should exist */}
        <Route index element={<Navigate to="/auth/login" />} />
      </Route>
    </Routes>
  );
};

export { AuthPage };
